const routes = {
  login: '/login',
  loginSso: '/login/sso/:registrationId',
  sessionExpiredSso: '/login/sso/:registrationId/expired',
  loginCallback: '/callback/:country?',
  loginSsoCallback: '/sso/callback',
  home: '/',
  teleid: '/teleid',
  telesign: '/telesign',
  safemail: '/safemail',
  safemailInbox: '/safemail/inbox',
  safemailNew: '/safemail/new',
  safemailOutbox: '/safemail/sent',
  safemailThread: '/safemail/thread/:threadId',
  admin: '/admin',
  adminUsers: '/admin/users',
  adminAddUser: '/admin/users/add',
  adminEditUser: '/admin/users/edit/:id',
  adminAdmins: '/admin/admins',
  adminTeleID: '/admin/teleid',
  adminTeleSign: '/admin/telesign',
  adminSafeMail: '/admin/safemail',
  profile: '/profile',
  validateEmail: '/email/validate',
  passwordReset: '/password/reset',
};

/**
 * react-router matches the paths of a *descendant* `<Routes>` relative to the
 * route that rendered it, so absolute paths (e.g. `/safemail/inbox`) never match
 * there. This strips a parent prefix off an absolute route so it can be used as a
 * descendant `<Route path>`, while the routes above stay absolute for navigation
 * (links, `navigate()`, `matchPath()`).
 *
 *   relativeTo(routes.safemail, routes.safemailInbox) // 'inbox'
 *   relativeTo(routes.adminUsers, routes.adminUsers)  // ''  (index)
 */
export const relativeTo = (parent: string, path: string): string =>
  path === parent ? '' : path.slice(parent.length + 1);

export default routes;
